import React from "react";
import { ChangePasswordSchema } from "../../../utils/validationSchema";
import { changePasswordAction, getProfile } from "../action";
import PasswordInputField from "../../../components/passwordInputField";
import { useFormik } from "formik";
import CustomModal from "../../../components/customModal";
import { useDispatch } from "react-redux";

const ChangePasswordModal = ({ visible, visibleHandler }) => {
  const dispatch = useDispatch();
  const initialValueOfChangePassword = {
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  };

  const changePassword = useFormik({
    initialValues: initialValueOfChangePassword,
    validationSchema: ChangePasswordSchema,
    onSubmit: (values, action) => {
      delete values.confirmPassword;
      dispatch(
        changePasswordAction(values, (response) => {
          if (response.isSuccess) {
            action.resetForm();
            visibleHandler();
          }
        })
      );
    },
  });

  const renderBody = () => {
    return (
      <div className="edit-profile-body-container">
        <div>
          <PasswordInputField
            label={"Old Password"}
            changeHandler={changePassword.handleChange}
            placeholderText={"Enter old password."}
            value={changePassword.values.oldPassword}
            name={"oldPassword"}
          />
          {changePassword.errors.oldPassword &&
            changePassword.touched.oldPassword && (
              <div className="change-password-error">
                {changePassword.errors.oldPassword}
              </div>
            )}
        </div>
        <div>
          <PasswordInputField
            label={"New Password"}
            changeHandler={changePassword.handleChange}
            placeholderText={"Enter new password."}
            value={changePassword.values.newPassword}
            name={"newPassword"}
          />
          {changePassword.errors.newPassword &&
            changePassword.touched.newPassword && (
              <div className="change-password-error">
                {changePassword.errors.newPassword}
              </div>
            )}
        </div>
        <div>
          <PasswordInputField
            label={"Confirm New Password"}
            changeHandler={changePassword.handleChange}
            placeholderText={"Enter new confirm password."}
            value={changePassword.values.confirmPassword}
            name={"confirmPassword"}
          />
          {changePassword.errors.confirmPassword &&
            changePassword.touched.confirmPassword && (
              <div className="change-password-error">
                {changePassword.errors.confirmPassword}
              </div>
            )}
        </div>
      </div>
    );
  };
  return (
    <CustomModal
      body={renderBody}
      confirmHandler={changePassword.handleSubmit}
      heading={"Change Password"}
      modalSize={"md"}
      visible={visible}
      visibleHandler={visibleHandler}
    />
  );
};

export default ChangePasswordModal;
